export default [
  {
    path: '/components',
    name: 'Components',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/Main.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'Components',
      requireAuth: true,
      requireAccount: true,
      title: 'Componentes'
    }
  },
  {
    path: '/customer-base',
    name: 'BaseList',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/customer-base/BaseList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/customer-base/create',
    name: 'BaseCreate',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/customer-base/BaseCreateUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/customer-base/:id',
    name: 'BaseRetrieve',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/customer-base/BaseRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/customer-base/:id/edit',
    name: 'BaseUpdate',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/customer-base/BaseCreateUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'BaseList',
      requireAuth: true,
      requireAccount: true,
      title: 'Customer Base'
    }
  },
  {
    path: '/signup-forms/create',
    name: 'FormCreate',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/signup-forms/FormCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'FormCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms/:id',
    name: 'FormDetail',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/signup-forms/FormDetail.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'FormList',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms',
    name: 'FormList',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/signup-forms/FormList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'FormList',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms/:id/preview',
    name: 'FormPreview',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/signup-forms/FormPreview.vue'),
    meta: {
      displayAppBar: false,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'FormPreview',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/signup-forms/:id/edit',
    name: 'FormUpdate',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/signup-forms/FormUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'FormUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Signup Forms'
    }
  },
  {
    path: '/components/links',
    name: 'LinkList',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/links/LinkList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'LinkList',
      requireAuth: true,
      requireAccount: true,
      title: 'Links'
    }
  },
  {
    path: '/components/links/create',
    name: 'LinkCreate',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/links/LinkCreateUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'LinkCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Links'
    }
  },
  {
    path: '/components/links/:id',
    name: 'LinkRetrieve',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/links/LinkRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'LinkRetrieve',
      requireAuth: true,
      requireAccount: true,
      title: 'Links'
    }
  },
  {
    path: '/components/links/:id/edit',
    name: 'LinkUpdate',
    component: () => import(/* webpackChunkName: "widgets" */ '@/views/widgets/links/LinkCreateUpdate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'LinkUpdate',
      requireAuth: true,
      requireAccount: true,
      title: 'Links'
    }
  }
]